import IconNameEnum from "constants/IconNameEnum";
import RouteEnum from "constants/RouteEnum";
import React from "react";
import { Button } from "react-bootstrap";
import ElementoModel from "stores/contenuto/models/ElementoModel";
import BaseIcon from "../base-form/BaseIcon";

interface IProps {
    element: ElementoModel;
    redirectToPage: (page: RouteEnum) => void;
}
interface IState {}

class BaseElement extends React.Component<IProps, IState> {
    public render(): JSX.Element {
        const { element, redirectToPage } = this.props;

        const id = "content-element-" + element.idElemento;

        switch (element.codiceTipoElemento) {
            case "IMG":
                return <img id={id} src={element.valore} width="100%" height="100%" alt={element.valore} />;
            case "VID":
                return (
                    <>
                        <video id={id} src={element.valore} width="100%" height="100%" controls></video>
                    </>
                );
            case "BTN":
                let btnStyle: string | undefined = undefined;
                switch (element.codiceStilePulsante) {
                    case "PRI":
                        btnStyle = "bg-ccq-yellow cq-text-blue";
                        break;
                    case "SEC":
                        btnStyle = "bg-ccq-blue text-white";
                        break;
                }

                let icon: IconNameEnum | undefined = undefined;
                switch (element.codiceIconaPulsante) {
                    case "CLC":
                        icon = IconNameEnum.Calcola;
                        break;
                }

                let action = () => {};
                switch (element.codiceAzionePulsante) {
                    case "HOM":
                        action = () => redirectToPage(RouteEnum.HOME);
                        break;
                }

                return (
                    <div className="w-100 text-center">
                        <Button id={id} className={btnStyle + " mt-3"} onClick={action}>
                            {icon ? <BaseIcon className="mr-2" icon={icon} /> : null}
                            {element.valore}
                        </Button>
                    </div>
                );
            case "LIN":
                return <hr id={id} className="w-100" />;
            default:
                let style = "";
                switch (this.props.element.codiceTipoElemento) {
                    case "TH1":
                        style = "h1 font-weight-bold cq-text-blue px-5 py-3";
                        break;
                    case "TH2":
                        style = "h4 px-5 py-3";
                        break;
                    case "NOT":
                        style = "text-muted small";
                        break;
                    case "CT1":
                        style = "cq-text-blue h5";
                        break;
                    case "CTX":
                        style = "text-muted card-text";
                        break;
                    case "T1N":
                        style = "h5";
                        break;
                }
                return <div id={id} className={style} dangerouslySetInnerHTML={{ __html: element.valore }}></div>;
        }
    }
}

export { BaseElement as Unconnected };
export default BaseElement;
